import {MouseEvent } from 'react';
import Button from '@mui/material/Button';
import RefreshIcon from '@mui/icons-material/Refresh';
import { useTranslation } from 'react-i18next';


interface RefreshButtonProps  {
    handler?: (event: MouseEvent<HTMLElement>) => void;
}


export default function RefreshButton( { handler } : RefreshButtonProps) {
    const { t } = useTranslation();

    return (
        <Button variant="text"
            color="primary"
            onClick={handler}
            sx={{
                pl: 2,
                pr: 2,
                borderRadius: 2,
                boxShadow: theme => '0px 0px 8px ' + theme.palette.grey.A200,
                background:'white 0% 0% no-repeat padding-box',
                color: 'secondary.main',
                fontWeight: 'bold',
                fontSize: {
                    xs: 12,
                    md: 13,
                    xl: 14,
                },

            }}
            startIcon={<RefreshIcon  />}
        >
            {t('app_refresh')}
        </Button>
    )

}